/**
 * 获取名字和前缀名
 * @param name
 * @returns [name, prefix]
 */
export function getPrefixName(name: string): [string, string | undefined] {
  if (!name.includes('.')) return [name, undefined]
  const nameSplit = name.split('.')
  return [nameSplit.at(-1)!, nameSplit[0]]
}
